import { IonButton, IonContent, IonLoading } from "@ionic/react";
import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "../utils/axiosInstance";
import { AppContext } from "../context";

const Process: React.FC = () => {
  const [showLoading, setShowLoading] = useState(true);
  const context: any = useContext(AppContext);
  let history = useHistory();

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const accessToken =
    window.localStorage.getItem("token") || query.get("accessToken");
  const memberId =
    window.localStorage.getItem("memberId") || query.get("memberId");
  useEffect(() => {
    const redirectUrl =
      process.env.REACT_APP_OAUTH_LOGIN_URL +
      `?redirect_url=${
        // eslint-disable-next-line no-restricted-globals
        location.protocol +
        "//" +
        // eslint-disable-next-line no-restricted-globals
        location.hostname +
        ":" +
        // eslint-disable-next-line no-restricted-globals
        location.port +
        // eslint-disable-next-line no-restricted-globals
        location.pathname
      }`;
    if (accessToken && memberId) {
      axios
        .get("/gateway/private/core/v1/profiles/" + memberId, {
          headers: { "X-Access-Token": accessToken },
        })
        .then((res) => {
          if (res.data.returnCode === "000000") {
            context.dispatch({
              type: "SET",
              payload: res.data.info,
            });
            const data = res.data.info
            localStorage.setItem("token", accessToken);
            localStorage.setItem("memberId", memberId);
            localStorage.setItem("projectCode", data.projectCode);
            localStorage.setItem("legalName", data.legalName);
            localStorage.setItem("email", data.email);
            localStorage.setItem("cellPhone", data.cellPhone);

            setShowLoading(false);

            history.push("/home");
          } else if (res.data.returnCode === "100003") {
            localStorage.clear();
            window.location.replace(redirectUrl);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // eslint-disable-next-line no-restricted-globals
      window.location.replace(redirectUrl);
    }
  }, [accessToken, context, history, memberId]);

  return (
    <IonContent>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        message={"Please wait..."}
        duration={5000}
      />
    </IonContent>
  );
};

export default Process;
